import { USER_ROLES } from "../constants/roles";

export const isInstitutionAdmin = (user) =>
  user?.role?.name === USER_ROLES.INSTITUTION_ADMIN;
